'use client';

import React, { useState, useEffect } from 'react';
import AppImage from '@/components/ui/AppImage';

const editorialSlides = [
{
  id: 'slide-001',
  category: 'Places',
  title: 'The Forgotten Palaces of Rajasthan',
  subtitle: 'Seventeen uninhabited royal residences — not one open to the public',
  image: "https://images.unsplash.com/photo-1703141833137-142b08306924",
  alt: 'Grand ornate palace facade with intricate carved stone arches in warm amber light at dusk'
},
{
  id: 'slide-002',
  category: 'Objects',
  title: 'The Patek Philippe Reference 2499',
  subtitle: 'The perpetual calendar that redefined what a wristwatch could mean',
  image: "https://images.unsplash.com/photo-1588136783893-999a3fd9fd31",
  alt: 'Close-up of luxury Swiss watch face with gold hands and complications on dark leather strap'
},
{
  id: 'slide-003',
  category: 'Experiences',
  title: 'A Private Dinner Inside the Louvre',
  subtitle: 'After closing — with one curator and no other guests',
  image: "https://images.unsplash.com/photo-1516308839639-14be4f9a2381",
  alt: 'Illuminated Louvre pyramid at night reflected in still water with empty courtyard'
}];


export default function EditorialPanel() {
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIdx((i) => (i + 1) % editorialSlides?.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const slide = editorialSlides?.[activeIdx];

  return (
    <div className="hidden lg:flex lg:w-[55%] xl:w-[60%] relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <AppImage
          src={slide?.image}
          alt={slide?.alt}
          fill
          className="object-cover transition-opacity duration-1000"
          priority />
        
        <div className="absolute inset-0 hero-overlay-bottom" />
        <div className="absolute inset-0 bg-obsidian/30" />
      </div>
      {/* Content */}
      <div className="relative z-10 flex flex-col h-full w-full">
        {/* Top brand identity */}
        <div className="px-12 pt-12">
          <div className="flex flex-col">
            <span className="font-editorial text-xs tracking-[0.3em] uppercase text-cream/60">
              The Private World
            </span>
            <span className="font-editorial text-3xl font-bold italic text-cream mt-1">
              of Luxury
            </span>
          </div>
          <div className="mt-4 w-12 h-px bg-gold" />
          <p className="mt-4 text-sm text-cream/70 max-w-xs leading-relaxed tracking-wide">
            Extraordinary discoveries. Collector intelligence. Curated exclusively for members who understand that the most remarkable things in the world are never widely known.
          </p>
        </div>

        {/* Bottom slide content */}
        <div className="mt-auto px-12 pb-12">
          <div className="mb-6">
            <span className="exclusivity-badge text-xs tracking-widest uppercase px-3 py-1 rounded-sm">
              {slide?.category}
            </span>
          </div>
          <h2 className="font-editorial text-3xl xl:text-4xl font-semibold text-cream leading-tight mb-3 animate-fade-in">
            {slide?.title}
          </h2>
          <p className="text-cream/70 text-sm leading-relaxed max-w-sm animate-fade-in">
            {slide?.subtitle}
          </p>

          {/* Slide indicators */}
          <div className="flex items-center gap-2 mt-8">
            {editorialSlides?.map((s, i) =>
            <button
              key={s?.id}
              onClick={() => setActiveIdx(i)}
              aria-label={`View slide ${i + 1}`}
              className={`transition-all duration-300 rounded-full ${
              i === activeIdx ?
              'w-8 h-1 bg-gold' : 'w-1 h-1 bg-cream/30 hover:bg-cream/60'}`
              } />

            )}
          </div>

          {/* Member count social proof */}
          <div className="mt-8 flex items-center gap-3">
            <div className="flex -space-x-2">
              {['av-1', 'av-2', 'av-3']?.map((id, i) =>
              <div
                key={`avatar-${id}`}
                className="w-7 h-7 rounded-full border border-muted bg-muted flex items-center justify-center"
                style={{ zIndex: 3 - i }}>
                
                  <span className="text-xs text-cream/70">{['C', 'A', 'R']?.[i]}</span>
                </div>
              )}
            </div>
            <p className="text-xs text-cream/50 tracking-wide">
              Joined by <span className="text-cream/80">2,847 members</span> from 61 countries
            </p>
          </div>
        </div>
      </div>
    </div>);

}